export const AMENITY_ICON_MAP = {
  "Wi-Fi": "/amenitiesIcon/wi-fi-icon.png",
  "FREE WiFi": "/amenitiesIcon/wi-fi-icon.png",
  "Wireless Internet": "/amenitiesIcon/wi-fi-icon.png",
  "Wireless / WiFi":"/amenitiesIcon/wi-fi-icon.png",
  "Air Conditioning": "/amenitiesIcon/air-conditioner.png",
  "AC": "/amenitiesIcon/air-conditioner.png",
  "Television": "/amenitiesIcon/television.png",
  "TV": "/amenitiesIcon/television.png",
  "Mini Bar": "/amenitiesIcon/miniBar.png",
  "Mini Refrigerator": "/amenitiesIcon/miniBar.png",
  "Tea Coffee Maker": "/amenitiesIcon/kitchen-appliance.png",
  "Coffee Maker": "/amenitiesIcon/kitchen-appliance.png",
  "Room Service": "/amenitiesIcon/room-service.png",
  "Housekeeping": "/amenitiesIcon/dailyCleaning.jpg",
  "Hair Dryer": "/amenitiesIcon/hairDrier.webp",
  "Hair dryer (on request)": "/amenitiesIcon/hairDrier.webp",
  "Iron": "/amenitiesIcon/iron.png",
  "Safe Locker": "/amenitiesIcon/safe-box.png",
  "In-room Safe": "/amenitiesIcon/safe-box.png",
  "Hand Soap": "/amenitiesIcon/liquid-soap.png",
  "Private Bathroom":"/amenitiesIcon/public-toilet.png",
  "Private bathroom with toiletries": "/amenitiesIcon/public-toilet.png",
  "Shower":"/amenitiesIcon/shower.jpg",
  "Toiletries":"/amenitiesIcon/toiletries.png",
  "Towels":"/amenitiesIcon/towel.jpg",
  "Air-conditioning":"/amenitiesIcon/air-conditioner.jpg",
  "Satellite / Cable TV":"/amenitiesIcon/communication.png",
  "Daily Housekeeping": "/amenitiesIcon/dailyCleaning.webp",
  "Free Parking":"/amenitiesIcon/parking-area.png",
  "Parking":"/amenitiesIcon/parking-area.png",
  "Room Slippers":"/amenitiesIcon/slippers.png",
  "Slippers (on request)": "/amenitiesIcon/slippers.png",
  "Tea/Coffee Making facilities":"/amenitiesIcon/coffee-machine.jpg",
  "Iron & ironing board":"/amenitiesIcon/iron.png",
  "Balcony": "/amenitiesIcon/balcony.png",
  "Desk": "/amenitiesIcon/frontDesk.webp",
  "Flat Screen TV": "/amenitiesIcon/tv-monitor.png",
  "In-room Safe Deposit Box":"/amenitiesIcon/safe-box.png",
   "In-room Safe":"/amenitiesIcon/safe-box.png",
  "Linen": "/amenitiesIcon/bed-sheets.png",
  "Mountain Views":"/amenitiesIcon/mountain.png",
  "Non Smoking Rooms": "/amenitiesIcon/nonSmokingRooms.png",
  "Pets Allowed": "/amenitiesIcon/pet.jpg",
  "Smoke Alarm": "/amenitiesIcon/smoke-detector.png",
  "Windows": "/amenitiesIcon/window.png",
  "Opening Windows": "/amenitiesIcon/openingWindow.png",
  "Fans":"/amenitiesIcon/ceiling-fan.png",
  "Privacy Curtains":"/amenitiesIcon/private.png",
  "Separate Shower & Bath": "/amenitiesIcon/public-toilet.png",
  "Air purifier":"/amenitiesIcon/air-purifier.png",
  "Bathrobes": "/amenitiesIcon/bathrobe.png",
  "Free Local Calls":"/amenitiesIcon/telephone.png",
  "Phone":"/amenitiesIcon/telephone.png",
  "Shared playground":"/amenitiesIcon/playground.png",
  "Electric Kettle":"/amenitiesIcon/kettle.png",
  "Coat Hangers":"/amenitiesIcon/clothes-rack.png",
  "Guest Laundry Facility":"/amenitiesIcon/laundry.png",
  "Free Tea/Coffee Making facilities":"/amenitiesIcon/coffee-machine.jpg",
  "Free Bottled Water":"/amenitiesIcon/drink.png",
  "Sofa":"/amenitiesIcon/sofa.png",
  "Shared Pool":"/amenitiesIcon/shared-pool.png",
  "Courtyard":"/amenitiesIcon/courtyard.png",
  "Separate Living Area":"/amenitiesIcon/living-room.png",
  "Vanity Basin & Mirror":"/amenitiesIcon/vanity-set.png",
  "Bathtub":"/amenitiesIcon/bathtub.png",
  "Bedside Lights":"/amenitiesIcon/night-stand.png",
  "Towels/Linen at Surcharge":"/amenitiesIcon/bed-sheets.png",
  "Free Washing Powder":"/amenitiesIcon/detergent.png",
  "Radio":"/amenitiesIcon/radio.png",
  "Alarm Clock":"/amenitiesIcon/alarm-clock.png",
  "Shower Over Bath":"/amenitiesIcon/shower.jpg",
  "Shared Bathroom": "/amenitiesIcon/public-toilet.png",
  "Accessible by Elevator": "/amenitiesIcon/lift-sign.png",
  "Electronic Door Lock": "/amenitiesIcon/digital-door.png",
  "Power": "/amenitiesIcon/charge.png",
  "Wake-up calls": "/amenitiesIcon/wake-up.png",
  "Wardrobe & luggage space": "/amenitiesIcon/wardrobe.png",
  "Complimentary drinking water": "/amenitiesIcon/drink (1).png",
};
